import { BUILD_INFO } from 'src/environments/build-info';

/**
 * The webpack content hash of the **main bundle actually running** (`main.<hash>.js`
 * — the value shown as the initiator in DevTools Network). Derived at runtime, so it
 * reflects a stale/cached page too — which is exactly the case that made a
 * `capture_stall` look like the new build when it was really the old cached one.
 */
export function runningBundleId(): string {
  try {
    const src = Array.from(document.getElementsByTagName('script'))
      .map((s) => s.src)
      .find((s) => /\/main\.[a-z0-9]+\.js/i.test(s));
    return src?.match(/main\.([a-z0-9]+)\.js/i)?.[1] ?? 'unknown';
  } catch {
    return 'unknown';
  }
}

/**
 * Build identity for telemetry + the harness version note: the `commit` + `time`
 * stamped at build (see scripts/gen-build-info.js) plus the runtime `bundle` hash.
 */
export function buildDescriptor(): { commit: string; time: string; bundle: string } {
  return { commit: BUILD_INFO.commit, time: BUILD_INFO.time, bundle: runningBundleId() };
}
